var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayEnjdrnwq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    height: 300,
    width: 300,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210 210"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.07 105L30.93 210V0l148.14 105z"
  })));
}
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIGZpbGw9IiNmZmYiIGhlaWdodD0iMzAwcHgiIHdpZHRoPSIzMDBweCIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgICAgdmlld0JveD0iMCAwIDIxMCAyMTAiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBkPSJNMTc5LjA3LDEwNUwzMC45MywyMTBWMEwxNzkuMDcsMTA1eiIvPgo8L3N2Zz4=";
export { SvgPlayEnjdrnwq as ReactComponent };